import axios from "../axios";
import h from "../helpers";

const warehouse = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("warehouse"), { params: { ...params } });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("warehouse/" + id));
    return data;
  },
};

export default warehouse;
